<template>
  <el-dialog
    :visible="detailDialogVisible"
    title="Banner详情"
    width="800px"
    @open="openDialog"
    @close="closeDialog"
     :before-close="handleClose"
  >
    <el-form
      :model="bannerDetail"
      ref="bannerForm"
      class="banner-form"
      :rules="rules"
      label-width="200px"
    >
      <!-- <el-form-item label="广告位置：" prop="type">
        <el-select :value="bannerDetail.type" @change="handleFormChange('type', $event)" placeholder="请选择">
          <el-option
            v-for="item in positionTypeList"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item> -->
      <div class="flex_div">
        <el-form-item label="场景：" prop="type">
          <el-select
            :value="bannerDetail.type"
            @input="handleFormChange('type', $event)"
            placeholder="请选择"
          >
            <el-option
              v-for="item in bannerTypes"
              :key="item.type"
              :label="item.message"
              :value="Number(item.type)"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="类型：" prop="bannertype">
          <el-select v-model="bannerDetail.bannerType" placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </div>
      <el-form-item label="标题：" prop="title">
        <el-input
          :value="bannerDetail.title"
          @input="handleFormChange('title', $event)"
        ></el-input>
      </el-form-item>
      <el-form-item label="图片：" prop="imageUrl">
        <upload
          :value="bannerDetail.imageUrl"
          @change="handleFormChange('imageUrl', $event)"
          :data="{
            language: this.bannerDetail.language,
            platform: this.bannerDetail.platform,
            category: 'banner',
          }"
        ></upload>
      </el-form-item>
      <el-form-item label="跳转地址：" prop="linkUrl">
        <el-input
          :value="bannerDetail.linkUrl"
          @input="handleFormChange('linkUrl', $event)"
        ></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="toggleDetailDialogVisible(false)">取消</el-button>
      <el-button type="primary" @click="handleSave('bannerForm')"
        >保存</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
import Upload from "components/upload";

export default {
  name: "BannerDetail",
  props: ["value"],
  data() {
    return {
      rules: {
        title: [{ required: true, message: "标题不能为空！" }],
        imageUrl: [{ required: true, message: "图片不能为空！" }],
      },
      options: [
        {
          value: "image",
          label: "图片",
        },
        {
          value: "custom",
          label: "自定义",
        },
      ],
    };
  },
  components: {
    Upload,
  },
  computed: {
    ...mapState("appFunctionalPageSetting", [
      "detailDialogVisible",
      "positionTypeList",
      "platformTypeList",
      "languageList",
      "bannerTypes",
    ]),
    ...mapGetters("appFunctionalPageSetting", ["bannerDetail", "bannerList"]),
  },
  methods: {
    ...mapActions("appFunctionalPageSetting", ["detail", "update", "list"]),
    ...mapMutations("appFunctionalPageSetting", [
      "toggleDetailDialogVisible",
      "setBannerDetail",
    ]),
    openDialog() {
      this.detail(this.value);
    },
    closeDialog() {
      this.toggleDetailDialogVisible(false);
    },
    handleFormChange(type, value) {
      this.setBannerDetail({
        ...this.bannerDetail,
        [type]: value,
      });
    },
    handleSave(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.update(this.bannerDetail).then(() => {
            this.$message({
              message: "修改成功！",
              type: "success",
            });
            this.toggleDetailDialogVisible(false);
            this.$emit("refresh");
          });
        }
      });
    },
    handleClose(done) {
        this.$confirm('确认关闭？')
          .then(_ => {
            done();
          })
          .catch(_ => {});
      }
  },
};
</script>

<style lang="less" scoped>
.banner-form {
  margin-right: 100px;
}
.flex_div {
  display: flex;
}
</style>
